import jwt_decode from "jwt-decode";
import { Injectable } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { Observable, ReplaySubject } from "rxjs";
import { DetailedAccessToken } from "src/app/models/auth0/detailed-access-token";
import { v4 as uuidv4 } from "uuid";

@Injectable({
    providedIn: "root",
})
export class UserService {
    private _isLoggedIn$ = new ReplaySubject<boolean>(1);
    private _zenityAccountId: string;
    private _loggedInUser: import("@auth0/auth0-spa-js").User;
    private _userPermissions: string[] = [];
    private _sessionId: string = uuidv4();
    private _userPermission: string;
    private _accountName: string;

    constructor(public auth: AuthService) {
        this.auth.user$.subscribe(
            (user) => {
                if (user && !this.loggedInUser) {
                    this._loggedInUser = user as import("@auth0/auth0-spa-js").User;
                    this._zenityAccountId = user["org_id"] as string;
                    this.auth.getAccessTokenSilently().subscribe(
                        (token) => {
                            const decoded_jwt = jwt_decode<DetailedAccessToken>(token);
                            const scope = decoded_jwt.scope;
                            this._accountName = decoded_jwt.accountName ?? "Unknown";
                            this._userPermissions = scope.split(" ");
                            this._getUserPermission(this._userPermissions);
                            this._isLoggedIn$.next(true);
                        },
                        () => this._isLoggedIn$.next(false),
                    );
                }
            },
            () => this._isLoggedIn$.next(false),
        );
    }

    public get sessionId(): string {
        return this._sessionId;
    }

    public get accountName(): string {
        return this._accountName;
    }

    public get userPermissions(): string[] {
        return this._userPermissions;
    }

    public get userPermission(): string {
        return this._userPermission;
    }

    public get loggedInUser(): import("@auth0/auth0-spa-js").User {
        return this._loggedInUser;
    }

    public get zenityAccountId(): string {
        return this._zenityAccountId;
    }

    public canLoadApp(): Observable<boolean> {
        return this._isLoggedIn$;
    }

    public logout() {
        this.auth.logout();
    }

    private _getUserPermission(permissions: string[]): void {
        for (const permissionIndex in permissions) {
            if (permissions[permissionIndex].startsWith("user")) {
                const splittedPermission = permissions[permissionIndex].split(":");
                this._userPermission = splittedPermission[1];
                return;
            }
        }
    }
}
